module.exports = __webpack_public_path__ + "img/video.57a8887b.png";